import { ITutorial, ITutorialPassos, MensagensPadrao } from "../../../Components/AdicionarAjuda";

export const IDs = {
    formularioDeFiltro: "formulario-de-filtros-agencia",

    filtroDeNomeAgencia: "campo-nome-filtros-agencia",
    filtroDeNumeroAgencia: "campo-numero-filtros-agencia",
    filtroDeAtivo: "campo-ativo-filtros-agencia",

    botaoListar: "botao-listar-agencias",
    botaoAdicionar: "botao-adicionar-agencia",
}

export const Classes = {
    botaoEditar: "botao-editar-agencia",
    botaoDesativar: "botao-desativar-agencia",
}

export const ConsultarAgencia: ITutorialPassos = {
    steps: [
        {...MensagensPadrao.filtros.apresentacao, target: () => document.getElementById(IDs.formularioDeFiltro)!},
        {...MensagensPadrao.filtros.nome, target: () => document.getElementById(IDs.filtroDeNomeAgencia)!},
        {
            title: "Filtro de número de agência",
            description: "Caso deseje filtrar pelo número de uma agência, especifique-o neste campo.",
            target: () => document.getElementById(IDs.filtroDeNumeroAgencia)!
        },
        {...MensagensPadrao.filtros.ativo, target: () => document.getElementById(IDs.filtroDeAtivo)!},
        {...MensagensPadrao.filtros.botaoListar, target: () => document.getElementById(IDs.botaoListar)!},
    ]
}

export const AdicionarAgencia: ITutorialPassos = {
    steps: [
        {...MensagensPadrao.adicionar.entrada, target: () => document.getElementById(IDs.botaoAdicionar)!},
    ]
}

export const EditarAgencia: ITutorialPassos = {
    steps: [
        {...MensagensPadrao.alterar.editar, target: () => document.querySelector('.' + Classes.botaoEditar)!},
    ]
}

export const DesativarAgencia: ITutorialPassos = {
    steps: [
        {...MensagensPadrao.alterar.desativar, target: () => document.querySelector('.' + Classes.botaoDesativar)!},
    ]
}

// const tutorialMenuItems: ITutorial[] = [
//     {
//         titulo: "Como consultar centros de custos",
//         tutorial: tutorialConsultarCentro
//     },
//     {
//         titulo: "Como cadastrar um novo centro de custos",
//         tutorial: tutorialAdicionarCentro
//     },
//     {
//         titulo: "Como editar um centro de custos",
//         tutorial: tutorialEditarCentro
//     },
//     {
//         titulo: "Como desativar um centro de custos",
//         tutorial: tutorialDesativarCentro
//     }
// ]